<template>
  <div class="login-wrap">
    <div class="row">
      <div class="col-sm-8 text-center col-sm-offset-2 col-md-6 col-md-offset-3 col-lg-4 col-lg-offset-4 push-50-t">
        <img src="../../assets/images/logo-login.png" alt="">
        <h2 class="push-50-t">{{ labelFieldTitle[actualLanguage] }}</h2>
        <div v-if="errorMsg" class="alert push-30-t alert-danger alert-dismissable">
          <p>{{errorMsg}}</p>
        </div>
        <form v-if="!registerSuccess" class="simple_form form-horizontal push-50-t">

            <div class="form-inputs">

              <div class="form-group">
                <div class="col-xs-6">
                  <div class="form-material form-material-primary">
                    <input :disabled="isRegistering" class="form-control string text optional form-control" v-model="userInfos.lastName" autofocus="autofocus" type="text" value="" id="user_lastName">
                    <label for="user_lastName">{{ labelFieldName[actualLanguage] }}</label>
                  </div>
                </div>
                <div class="col-xs-6">
                  <div class="form-material form-material-primary">
                    <input :disabled="isRegistering" class="form-control string text optional form-control" v-model="userInfos.name" autofocus="autofocus" type="text" value="" id="user_name">
                    <label for="user_name">{{ labelFieldFirstName[actualLanguage] }}</label>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <div class="col-xs-12 ">
                  <div class="form-material form-material-primary">
                    <input :disabled="isRegistering" class="form-control string email optional form-control" v-model="userInfos.email" type="email" value="" id="user_email">
                    <label for="user_email">{{ labelFieldEmail[actualLanguage] }}</label>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <div class="col-xs-12 ">
                  <div class="form-material form-material-primary">
                    <input :disabled="isRegistering" class="form-control password optional form-control" v-model="userInfos.password" type="password" name="user[password]" id="user_password">
                    <label for="user_password">{{ labelFieldPW[actualLanguage] }}</label>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <div class="col-xs-12 ">
                  <div class="form-material form-material-primary">
                    <input :disabled="isRegistering" class="form-control password optional form-control" v-model="userInfos.repassword" type="password" name="user[password]" id="user_repassword">
                    <label for="user_repassword">{{ labelFieldConfirmPW[actualLanguage] }}</label>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-actions">
              <div class="col-xs-12 text-center push-30-t">
                <button v-if="!isRegistering" type="button" @click="register" style="min-width: 250px" class="btn btn-connexion btn-success">{{ labelFieldButtonSubscribe[actualLanguage] }}</button>
                <spinner v-else></spinner>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-12 text-center" style="margin-top: 100px">
                <p>{{ labelFieldAlready[actualLanguage] }}
                  <router-link style="margin-left: 5px" class="btn btn-default btn-rounded"  :to="{name: 'login'}">
                    {{ labelFieldButtonLogIn[actualLanguage] }}
                  </router-link>
                </p>
              </div>
            </div>

            <div class="form-actions">
              <div class="col-xs-12 text-center push-30-t">
                <button type="button" @click="toggleLanguage" style="min-width: 250px" class="btn btn-default btn-rounded">{{ labelFieldButtonLanguage[actualLanguage] }}</button>

              </div>
            </div>


          </form>
      </div>
    </div>
  </div>
</template>

<script>

import {mapState} from 'vuex'
import Spinner from '../../components/Spinner'
import VerifyForm from './Verify'


export default {
  components: {
    Spinner,
    VerifyForm
  },
  name: 'login',
  data () {
    return {
      userInfos: {
        name: '',
        lastName: '',
        email: '',
        password: '',
        repassword: '',
        verifyCode: ''
      },
      isRegistering: false,
      registerSuccess: false,
      errorMsg: '',

      actualLanguage : "FR",
      labelFieldTitle: {FR: 'Inscription', EN: 'Subscribe'},
      labelFieldName: {FR: 'Nom', EN: 'Last name'},
      labelFieldFirstName: {FR: 'Prénom', EN: 'First name'},
      labelFieldEmail: {FR: 'Adresse courriel', EN: 'Email'},
      labelFieldPW: {FR: 'Mot de passe', EN: 'Password'},
      labelFieldConfirmPW: {FR: 'Confirmation du mot de passe', EN: 'Confirm password'},
      labelFieldButtonSubscribe: {FR: "S'inscrire", EN: 'Subscribe'},
      labelFieldAlready: {FR: "Vous avez déjà un compte ?", EN: 'You already have an account ?'},
      labelFieldButtonLogIn: {FR: "Se connecter", EN: 'Log in'},
      labelFieldButtonLanguage: {FR: 'English version', EN: 'Version française'},
    }
  },

  mounted() {
    if(localStorage.language){this.actualLanguage =  localStorage.language}
    else{this.actualLanguage = 'FR'}
  },

  methods: {
    register() {
      this.isRegistering = true
      this.$store.dispatch('sessionStore/register', this.userInfos)
      .then((user) => {
        this.isRegistering = false
        this.$router.push({name: "verify"})
      })
      .catch((e) => {
        this.errorMsg = e.message
        this.isRegistering = false
      })
    },

    toggleLanguage(){
      if(this.actualLanguage =='FR'){
        this.actualLanguage ='EN'
        localStorage.language = 'EN'
      }
      else{
        this.actualLanguage ='FR'
        localStorage.language = 'FR'
      }
      location.reload()
      }, 
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>



// WEBPACK FOOTER //
// Register.vue?7b76cd2b